import axios from 'axios'
import apiUtils from './apiUtils'

const apiParams = {
  baseURL: `${process.env.BASE_API_URL}/`,
}

apiParams.withCredentials = false
apiParams.transformResponse = [(data) => apiUtils.checkResponse(data)]

apiParams.validateStatus = function (status) {
  window.vm.showSpinner = false

  if (status === 401 || status === 403) {
    window.vm.$store.dispatch('users/forceLogoutUser')
    window.vm.$router.push('/auth')
  }

  if (status == 404) {
    window.vm.$router.push('/404')
  }

  if (status >= 200 && status < 400) {
    return true
  }

  return false
}

const azureCode = process.env.API_CODE
const apiAxios = axios.create(apiParams)

apiAxios.interceptors.request.use((config) => {
  window.vm.showSnackbar = false
  return config
})

apiAxios.interceptors.response.use((response) => {
  window.vm.showSpinner = false

  return response
})

export default {
  getApiParams() {
    return apiParams
  },
  loginUser(email, password) {
    return apiAxios.post(`/TempLogin/Login?code=${azureCode}`, { email, password })
  },
  getConfig() {
    return apiAxios.get(`/Config/GetConfigs?code=${azureCode}`)
  },
  searchForOrder(accountName, searchText) {
    return apiAxios.get(`/Kiosk/GetOrderReference?code=${azureCode}&searchText=${searchText}&accountName=${accountName}`)
  },
  startTerminalTransaction(orderNumber, salesOrderId, accountName, stationId, windcaveUat) {
    return apiAxios.post(
      `/Kiosk/StartTerminalTransaction?code=${azureCode}&orderNumber=${orderNumber}&salesOrderId=${salesOrderId}&accountName=${accountName}&stationId=${stationId}&useWindcaveUat=${windcaveUat}`
    )
  },
  getTerminalTransactionStatus(orderNumber, salesOrderId, accountName, stationId, windcaveUat) {
    return apiAxios.post(
      `/Kiosk/CheckTerminalTransactionStatus?code=${azureCode}&orderNumber=${orderNumber}&salesOrderId=${salesOrderId}&accountName=${accountName}&stationId=${stationId}&useWindcaveUat=${windcaveUat}`
    )
  },
  sendButtonRequest(orderNumber, salesOrderId, accountName, stationId, windcaveUat, button, buttonVal) {
    return apiAxios.post(
      `/Kiosk/SendButtonRequest?code=${azureCode}&orderNumber=${orderNumber}&salesOrderId=${salesOrderId}&accountName=${accountName}&stationId=${stationId}&useWindcaveUat=${windcaveUat}&button=${button}&buttonVal=${buttonVal}`
    )
  },
  moveOrderToAwaitingPick(salesOrderId, accountName) {
    return apiAxios.post(`/Kiosk/MakeOrderCollectableForScanner?code=${azureCode}&id=${salesOrderId}&accountName=${accountName}`)
  },
  getCollectionNotePdf(salesOrderId, accountName) {
    return apiAxios.get(`/PdfPrint/CollectionNote?code=${azureCode}&salesOrderId=${salesOrderId}&accountName=${accountName}`)
  },
}
